

















import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import BaseSelectSingle from '@/base/app/components/atoms/BaseSelectSingle.vue';

import {
  GroupLimitationFormValue,
  PropsGroupLimitationForm,
  useGroupLimitationForm,
} from './GroupLimitationFormComposable';

type Props = PropsGroupLimitationForm;

export default defineComponent({
  name: 'AdminGroupLimitationForm',
  components: { BaseSelectSingle },
  inheritAttrs: false,
  model: { prop: 'value', event: 'submit' },
  props: {
    value: { type: String as PropType<GroupLimitationFormValue>, default: undefined },
  },
  emits: ['submit'],
  setup(props: Props, { emit }: SetupContext) {
    return useGroupLimitationForm(props, emit);
  },
});
